module.exports = __webpack_public_path__ + "img/when-i-was-kid.0bb24a2e.jpg";